export default "__VITE_ASSET__BiunZkjj__"